import { Form, Formik } from 'formik';
import TextField from '../text-field/text-field';
import SelectField from '../select-field/select-field';
import { companySignUpSchema } from '../../utils/formSchema';
import { CompanySignUpFormInput } from '../../interfaces/interfaces';
import { COMPANY_TYPE_OPTIONS, USER_ROLE_OPTIONS } from '../../utils/constants';
import { FormErrorPanel } from '../form-error-panel/form-error-panel';
import styles from './company-sign-up.module.scss';

const ROLE_OPTIONS = USER_ROLE_OPTIONS.map((role) => ({
  value: role,
  label: role,
}));

const COMPANY_TYPE_SELECT_OPTIONS = COMPANY_TYPE_OPTIONS.map((type) => ({
  value: type,
  label: type,
}));

interface CompanySignUpFormProps {
  email: string;
  error?: string;
  onSubmit: (values: CompanySignUpFormInput) => Promise<void>;
}

export function CompanySignUpForm({
  email,
  error,
  onSubmit,
}: CompanySignUpFormProps) {
  const initialValues: CompanySignUpFormInput = {
    email,
    firstName: '',
    lastName: '',
    role: '',
    companyName: '',
    companyWebsite: '',
    companyType: '',
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={companySignUpSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values }) => (
        <Form className={styles['page']}>
          <div className={styles['header']}>
            <p className={styles['title']}>Company Sign Up</p>
          </div>
          <div className={styles['fields']}>
            <TextField
              label="Work Email"
              name="email"
              readOnly
              autoFocus={false}
            />
            <TextField label="Your First Name" name="firstName" />
            <TextField
              label="Your Last Name"
              name="lastName"
              autoFocus={false}
            />
            <SelectField label="Your Role" name="role" options={ROLE_OPTIONS} />
            <div className={styles['divider']} />
            <TextField
              label="Company Name"
              name="companyName"
              autoFocus={false}
            />
            <TextField
              label="Company Website"
              name="companyWebsite"
              autoFocus={false}
            />
            <SelectField
              label="Company Type"
              name="companyType"
              options={COMPANY_TYPE_SELECT_OPTIONS}
            />
          </div>
          <FormErrorPanel message={error} />
          <div className={styles['footer']}>
            <button
              type={'submit'}
              disabled={
                isSubmitting || !companySignUpSchema.isValidSync(values)
              }
              className={styles['sign-up-button']}
            >
              Sign up
            </button>
            <div className={styles['sign-in-row']}>
              Already have an account?{' '}
              <a href={`/authorize`}>Sign in to SPINS account</a>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default CompanySignUpForm;
